import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/literata/opsz.css';
import '@fontsource-variable/literata/opsz-italic.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/400-italic.css';
import '@fontsource/ibm-plex-mono/500.css';
import './styles/tokens.css';
import './styles/canvas.css';
import './styles/window.css';
import './styles/head.css';
import './styles/editor.css';
import './styles/controls.css';
import './styles/palette.css';
import './styles/brand.css';
import './styles/cloud.css';
import './styles/workspaces.css';
import { App } from './app/App';
import { AppContext } from './app/context';
import { createController } from './app/controller';
import { createBrowserFileAdapter } from './platform/files';
import { createIndexedDbStorage } from './platform/storage';
import { installMotionTokens } from './motion/motion';
import { createCloud } from './cloud';

async function start() {
  installMotionTokens();
  const [storage, cloud] = await Promise.all([createIndexedDbStorage(), createCloud()]);
  const app = createController({ storage, files: createBrowserFileAdapter(), cloud });
  await app.init();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppContext.Provider value={app}>
        <App />
      </AppContext.Provider>
    </StrictMode>,
  );
}

start();
